export default [
  {
    name: 'cupons',
    path: '/settings/cupons',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Cupons de Descontos',
      icon: 'dvr',
      label: 'Cupons de Descontos',
      roles: ['Admin']
    }
  }
]
